import { http } from '@/api/http'
import type { ProductGroup } from '@/types/api'
import { createCrudService } from '../crud'

export type ProductGroupLine = { product_id: string; weight: string }

export type ProductGroupInput = Pick<
  ProductGroup,
  'partner_id' | 'name_en' | 'name_ru' | 'name_uz' | 'name_cyr' | 'status'
> & { items: ProductGroupLine[] }

/** Metadata update never carries composition: that is its own command. */
export type ProductGroupUpdate = Partial<Omit<ProductGroupInput, 'items'>>

const crud = createCrudService<ProductGroup, ProductGroupInput, ProductGroupUpdate>('product-groups')

export const productGroupsService = {
  ...crud,
  async replaceComposition(id: string, items: ProductGroupLine[]) {
    const { data } = await http.put<ProductGroup>(`/product-groups/${encodeURIComponent(id)}/composition`, { items })
    return data
  },
}
